import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import axios from 'axios';

window.Pusher = Pusher;

//@configure echo instance with dynamic token
const echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_APP_KEY || 'cyberprotection-key-2025',
    wsHost: process.env.VUE_APP_PUSHER_HOST || 'localhost',
    wsPort: process.env.VUE_APP_PUSHER_PORT || 6001,
    wssPort: process.env.VUE_APP_PUSHER_PORT || 6001,
    forceTLS: false,  // Changed this to always be false
    encrypted: false,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    authEndpoint: (process.env.VUE_APP_API_URL || 'http://localhost:8001') + '/broadcasting/auth',
    authorizer: (channel) => {
        return {
            authorize: (socketId, callback) => {
                axios.post((process.env.VUE_APP_API_URL || 'http://localhost:8001') + '/broadcasting/auth', {
                    socket_id: socketId,
                    channel_name: channel.name
                }, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                        Accept: 'application/json'
                    }
                })
                .then(response => {
                    callback(false, response.data);
                })
                .catch(error => {
                    console.error('Broadcasting auth error:', error.response || error);
                    callback(true, error);
                });
            }
        };
    }
});

export default echo;

